import type { ReactNode } from 'react';

export const symbol_unsubscribe: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h680q23 0 41.5 18.5T880-740v237q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-177L496-473q-4 2-7.5 3t-8.5 1q-5 0-8.5-1t-7.5-3L140-680v460h356q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm340-367 340-213H140l340 213ZM140-220v-254 5-211 7-43.5.5-24 24.09-.37V-673v-7 460ZM640.5-94Q586-148 586-226.01q0-78.02 54.5-133Q695-414 773-414t132.5 54.99q54.5 54.98 54.5 133Q960-148 905.5-94 851-40 773-40T640.5-94ZM680-210h186q8 0 14-6t6-14q0-8-6-14t-14-6H680q-8 0-14 6t-6 14q0 8 6 14t14 6Z"
		/>
	</svg>
);
